const EXPIRED_STATUSES = new Set(['expired', 'canceled', 'cancelled'])
const NOT_EXPIRED_STATUSES = new Set(['active', 'pending'])

export const resolveIsExpired = ({ status, expirationDate }) => {
  if (typeof status === 'string') {
    const normalized = status.toLowerCase()
    if (EXPIRED_STATUSES.has(normalized)) {
      return true
    }
    if (NOT_EXPIRED_STATUSES.has(normalized)) {
      return false
    }
  }

  if (expirationDate == null) return false

  const expires = Date.parse(expirationDate)
  return Number.isFinite(expires) && Date.now() > expires
}

export const findExpiredAdminLicenses = licenses =>
  licenses.filter(license => {
    const isAdminLicense = license.claims.find(
      claim => claim.toLowerCase() === 'admin',
    )

    if (isAdminLicense) return license
  })

export const findExpiredNonAdminLicenses = licenses =>
  licenses.filter(license => {
    const isAdminLicense = license.claims.find(
      claim => claim.toLowerCase() === 'admin',
    )
    const isNonAdminLicense = license.claims.find(
      claim => claim.toLowerCase() === 'teacher',
    )
    if (!isAdminLicense && isNonAdminLicense) return license
  })

export const getExpiredLicensesWithClaims = sites => {
  const expiredLicenses = (sites || []).reduce((expLicenseAcc, site) => {
    const { claims } = site
    ;(site?.licenses || []).forEach(license => {
      if (
        license.isExpired &&
        !license.cancelledDate &&
        license.product?.programCodes
      ) {
        const {
          id,
          expirationDate,
          siteName,
          product: { programCodes, type },
        } = license
        const licenseWithClaims = {
          id,
          expirationDate,
          siteName,
          product: {
            programCodes,
            type,
          },
          claims,
        }
        expLicenseAcc.push(licenseWithClaims)
      }
    })
    return expLicenseAcc
  }, [])
  return expiredLicenses
}
